<mat-card [ngClass]="removeElevation ? 'mat-elevation-z0' : ''" class="cb-margin">
    <mat-card-content class="start-center mat-card-content-row">
        <mat-icon [ngClass]="alertClass"
                  class="cb-margin-right">
            {{ icon }}
        </mat-icon>
        <span>{{ message }}</span>
    </mat-card-content>
</mat-card>
